import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AppConfigService } from '../../app-config.service';

@Injectable({ providedIn: 'root' })
export class AccessBillingGuard {
  constructor(private router: Router, private app: AppConfigService) {}

  canLoad(): boolean {
    const hasAccess =
      this.app.config.userCanAccessBilling ||
      this.app.config.userCanAccessRetailBilling ||
      this.app.config.isImpersonated ||
      this.app.config.isSuperAdmin;
    if (!hasAccess) {
      this.router.navigateByUrl('dashboard');
    }
    return hasAccess;
  }
}
